var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_89365",
    "data-name": "Group 89365",
    xmlns: "http://www.w3.org/2000/svg",
    width: 156.282,
    height: 157.706,
    viewBox: "0 0 156.282 157.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M44.609,46.056A77.958,77.958,0,0,1,57.62,2.856a78.37,78.37,0,1,0,88.456,118.1,78.4,78.4,0,0,1-101.467-74.9Z",
    transform: "translate(-2.297 1.559)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M51.715,41.809H33.227L50.893,9.176V6.19H14.947V18.479H31.531L13.778,51.36v2.745H51.715Z",
    transform: "translate(62.904 20.493)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M36.554,30.28,50.48,4.553V2.2H22.141v9.691H35.211L21.219,37.807v2.164h29.9V30.28Z",
    transform: "translate(105.162 -2.195)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.8cb4d48231acecbb3ed9852fa080f144.svg";
export { ForwardRef as ReactComponent };